import { SVGProps, Ref, forwardRef } from 'react';

export const RadioCircleSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path d="M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4" fill="currentColor" />
    </svg>
));
RadioCircleSize16Glyph.displayName = 'RadioCircleSize16Glyph';
